// Re-export individual classes for pattern: import { TestBeginEventRequest } from "@stanterprise/protobuf/testsystem/v1/events"
import { testsystem as eventsNS } from '../../../lib/testsystem/v1/events/events';

// Export individual event classes
export type TestBeginEventRequest = eventsNS.v1.events.TestBeginEventRequest;
export const TestBeginEventRequest = eventsNS.v1.events.TestBeginEventRequest;

export type TestEndEventRequest = eventsNS.v1.events.TestEndEventRequest;
export const TestEndEventRequest = eventsNS.v1.events.TestEndEventRequest;

export type StepBeginEventRequest = eventsNS.v1.events.StepBeginEventRequest;
export const StepBeginEventRequest = eventsNS.v1.events.StepBeginEventRequest;

export type StepEndEventRequest = eventsNS.v1.events.StepEndEventRequest;
export const StepEndEventRequest = eventsNS.v1.events.StepEndEventRequest;

export type TestFailureEventRequest = eventsNS.v1.events.TestFailureEventRequest;
export const TestFailureEventRequest = eventsNS.v1.events.TestFailureEventRequest;

export type TestErrorEventRequest = eventsNS.v1.events.TestErrorEventRequest;
export const TestErrorEventRequest = eventsNS.v1.events.TestErrorEventRequest;

export type StdErrorEventRequest = eventsNS.v1.events.StdErrorEventRequest;
export const StdErrorEventRequest = eventsNS.v1.events.StdErrorEventRequest;

export type StdOutputEventRequest = eventsNS.v1.events.StdOutputEventRequest;
export const StdOutputEventRequest = eventsNS.v1.events.StdOutputEventRequest;

export type SuiteBeginEventRequest = eventsNS.v1.events.SuiteBeginEventRequest;
export const SuiteBeginEventRequest = eventsNS.v1.events.SuiteBeginEventRequest;

export type SuiteEndEventRequest = eventsNS.v1.events.SuiteEndEventRequest;
export const SuiteEndEventRequest = eventsNS.v1.events.SuiteEndEventRequest;

export type HeartbeatEventRequest = eventsNS.v1.events.HeartbeatEventRequest;
export const HeartbeatEventRequest = eventsNS.v1.events.HeartbeatEventRequest;

export type ReportRunStartEventRequest = eventsNS.v1.events.ReportRunStartEventRequest;
export const ReportRunStartEventRequest = eventsNS.v1.events.ReportRunStartEventRequest;

export type TestRunEndEventRequest = eventsNS.v1.events.TestRunEndEventRequest;
export const TestRunEndEventRequest = eventsNS.v1.events.TestRunEndEventRequest;
